import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from '../BasicElement';
import Button, { ILink } from '../Button';
import Image, { IImage } from '../Image';
export interface IVHSTilesItems {
	/**
	 * Item Image
	 */
	image?: IImage;
	/**
	 *  Item Heading
	 */
	heading: string;
	/**
	 *  Item Text
	 */
	text: string;
	/**
	 * Button
	 */
	button?: ILink;
	/**
	 *  Item Footnote
	 */
	footnote: string;
}

export interface IVHSTilesProps extends IBaseElementProps {
	/**
	 * Style
	 */
   style:  'primary' | 'secondary';
	/**
	 * Heading
	 */
	heading?: string;
	/**
	 * Items
	 */
	items?: IVHSTilesItems[];
	/**
	 * CTA
	 */
	cta?: ILink;
	/**
	 * CTA Style
	 */
	ctaStyle?:  'primary' | 'secondary';
	/**
	 * CTA Size
	 */
	ctaSize?:  'large' | 'small';
}

/**
 * Tiles
 * @block
 * @icon columns
 */
const VHSTiles: React.FC<IVHSTilesProps> = ({
	style,
	heading,
	items = [],
	cta,
	ctaStyle,
	ctaSize,
}) => (
	<div
		className={cn(
			'vhs-tiles',
			(style === 'secondary') && 'vhs-tiles--secondary',
		)}
	>
		<div className="vhs-tiles__container">
			<div className="vhs-tiles__wrapper">
				{heading && <h2 className="vhs-tiles__heading">{heading}</h2>}
				{items.length > 0 &&
					<ul className="vhs-tiles__items">
						{items.map(({ image, heading, text, button, footnote }, index) =>
							<li
								className={cn(
									'vhs-tiles__item',
									!footnote && 'vhs-tiles__item--positioned',
								)}
								key={index}
							>
								{image?.src && (
									<div className="vhs-tiles__image-wrapper">
										<Image
											{...image}
											className="vhs-tiles__image img-fluid"
										/>
									</div>
								)}
								<div
									className={cn(
										'vhs-tiles__content',
										(!footnote || footnote === '') && 'vhs-tiles__content--positioned',
									)}
									>
									{heading && <h3 className="vhs-tiles__subheading">{heading}</h3>}
									{text && <p className="vhs-tiles__text">{text}</p>}
									{button?.label && (
										<Button
											{...button}
											className={cn(
												'vhs-tiles__button  btn btn-sm btn-primary',
												(!footnote || footnote === '') && 'vhs-tiles__button--positioned-mobile',
											)}
										/>
									)}
									{footnote && <p className="vhs-tiles__footnote">{footnote}</p>}
								</div>
								{(!footnote || footnote === '') && button?.label && (
									<Button
										{...button}
										className="vhs-tiles__button vhs-tiles__button--positioned-desktop btn btn-sm btn-primary"
									/>
								)}
							</li>
						)}
					</ul>
				}
				{cta?.label && (
					<Button
						{...cta}
						className={cn(
							'vhs-tiles__cta btn btn-primary',
							(ctaStyle === 'secondary') && 'btn-secondary',
							(ctaSize === 'small') && 'btn-sm',
						)}
					/>
				)}
			</div>
		</div>
	</div>
);

export default VHSTiles;
